import React from "react";
import { Renderhamburgermenu } from "../hamburger/hamburger-menu";
import { formatDate } from "../../Utils/format-date.js";
import CompletedAssessmentImg from "../../../images/new-images/CompletedAssessmentImg.png";
import { Row, Col } from "reactstrap";
import "./CompletedAssessment.css";
import Rendermodals from "../Modals/modal";
import Renderinviterespondantsmodal from "./Invite-Respondants-Modal/invite-respondants-modal";
const CompletedAssessment = (props) => {
  const userName =
    localStorage.getItem("user_name") === "null"
      ? "-"
      : localStorage.getItem("user_name");

  return (
    <React.Fragment>
      <Renderhamburgermenu
        link1="/new/app/dashBoard"
        link2="/new/app/Invitations"
        text1="Dashboard"
        text2="Invitations"
        reviewMode={props.reviewMode}
      />
      <div className="layout">
        <Row>
          <Col md="8">
            <p className="Congratulations">Congratulations, {userName}!</p>
            <p className="You-have-completed-your-self-assessment">
              You have completed your assessment
            </p>
            <div className="assessment-details">
              <Row>
                <Col md="2">
                  <img
                    className="assessment-Icon"
                    src={
                      localStorage.getItem("baseLink") +
                      `/media/` +
                      (props.userCompletedAssessmentDetails &&
                        props.userCompletedAssessmentDetails
                          .instrument__instrument_image)
                    }
                  />
                </Col>
                <Col md="10">
                  <p className="assessment-name">
                    {props.userCompletedAssessmentDetails &&
                      props.userCompletedAssessmentDetails
                        .instrument__dashboard_header_text}
                  </p>
                  <p className="participant-name">
                    <span style={{marginRight:'5px'}}>
                      {props.userCompletedAssessmentDetails &&
                        props.userCompletedAssessmentDetails
                          .participant__full_name}
                      's 
                    </span>

                    {props.userCompletedAssessmentDetails &&
                      props.userCompletedAssessmentDetails
                        .instrument__instrument_name}
                  </p>
                  <p className="Expiry-date">
                    Completed on <span>{formatDate(Date())}</span>
                  </p>
                </Col>
              </Row>
            </div>
            <p className="invitation-text">
              Now, invite at least {props.getMinBatchRespondents} respondents
              and get their feedback
            </p>

            <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-start' }}>
              <button
                className="submit-button"
                onClick={props.handleAssessmentSubmit}
              >
                INVITE RESPONDENTS
              </button>
              <button
                className="submit-button"
                onClick={() => window.location.href = '/new/app/dashBoard'}
              >
                SKIP
              </button>
            </div>
            
          </Col>
          <Col md="4">
            <div className="flex-wrapper">
              <img className="image" src={CompletedAssessmentImg} />
            </div>
          </Col>
        </Row>
      </div>
      <Rendermodals
        assessmentModal={props.assessmentModal}
        handleModalClose={props.handleModalClose}
        modalHeading="INVITE RESPONDENTS"
        button2="Submit"
      >
        <Renderinviterespondantsmodal
          inputFields={props.inputFields}
          handleInputFields={props.handleInputFields}
          handleMultipleEmail={props.handleMultipleEmail}
          isEmailValid = {props.isEmailValid}
          handleMultipleSelect={props.handleMultipleSelect}
          isChecked={props.isChecked}
          isDisabled={props.isDisabled}
          handleModalFormSubmit={props.handleModalFormSubmit}
          dropDownOptions={props.dropDownOptions}
          handleInviteModalSubmit={props.handleInviteModalSubmit}
          isPopOverOpenRelationshipName={props.isPopOverOpenRelationshipName}
          overlayIsVisible={props.overlayIsVisible}
          relationShipName={props.relationShipName}
          handleClosePopOver={props.handleClosePopOver}
        />
      </Rendermodals>
    </React.Fragment>
  );
};

export default CompletedAssessment;



// WEBPACK FOOTER //
// ./src/new/Components/CompletedAssessment/CompletedAssessment.jsx